import { showError } from './iziToast-helper';
import { injectSchema } from './seo-function';
import { handleCategoryCardClick } from './categories-card-click';
import { cancelLoader, startLoader } from './loader';
import { YourEnergyAPI } from './api';
import { renderPaginationUniversal } from './pagination';
import { loadExercisesList } from './exercises-list.js';
import { setOpenExercises } from './state.js';
import { resetExercisesSearch } from './exercises-search';
import { scrollToFilter } from './scrollToFilter';

export const fetchApi = new YourEnergyAPI();

const PAGE_LIMIT = window.innerWidth < 768 ? 9 : 12;

// UI state
let activeFilter = window.activeFilter || 'Muscles';
let activePage = 1;

/**
 * ✅ Єдина мапа для всіх табів
 * Уніфікує: де рендерити картки і куди рендерити пагінацію
 */
const FILTER_UI = {
  Muscles: {
    cardsId: 'cards-container',
    paginationSel: '.js-categories-pagination',
  },
  Equipment: {
    cardsId: 'cards-container-equipment',
    paginationSel: '.js-equipment-pagination',
  },
  'Body parts': {
    cardsId: 'cards-container',
    paginationSel: '.js-categories-pagination',
  },
};

function getActiveUI() {
  return FILTER_UI[window.activeFilter] || FILTER_UI.Muscles;
}

export async function getCategories(
  filter = activeFilter,
  page = 1,
  limit = PAGE_LIMIT
) {
  activeFilter = filter;
  window.activeFilter = activeFilter;
  activePage = page;

  try {
    const params = { filter, page, limit };
    startLoader();
    const data = await fetchApi.getFilters(params);

    if (!data) {
      showError('Failed to fetch categories: No response from server');
      clearCards();
      clearPagination();
      return;
    }

    if (data.error || data.status === 'error') {
      showError(data.message || 'Failed to fetch categories');
      clearCards();
      clearPagination();
      return;
    }

    if (!data.results || data.results.length === 0) {
      showError('Nothing found');
      clearCards();
      clearPagination();
      return;
    }

    const results = data.results || [];
    const totalPages = data.totalPages || 1;

    renderCards(results);
    renderPagination(activePage, totalPages);

    if (typeof injectSchema === 'function') {
      injectSchema(data);
    }
  } catch (err) {
    console.error('getCategories error:', err);
    showError(err?.message || 'Something went wrong');
    clearCards();
    clearPagination();
  } finally {
    cancelLoader();
  }
}

// Cards
function renderCards(items) {
  const ui = getActiveUI();
  const container = document.getElementById(ui.cardsId);
  if (!container) return;

  container.innerHTML = '';

  items.forEach(item => {
    const card = document.createElement('div');
    card.className = 'card';

    const safeImg =
      item.imgURL && item.imgURL.trim() !== ''
        ? item.imgURL
        : '/img/no-image.jpg';

    const safeName = item.name || '';
    const safeFilter = item.filter || '';

    card.innerHTML = `
      <img src="${safeImg}" alt="${safeName}" loading="lazy" />
      <div class="card-body">
        <h3>${safeName}</h3>
        <span>${safeFilter}</span>
      </div>
    `;

    card.addEventListener('click', () => handleCategoryCardClick(item));
    container.appendChild(card);

    const cardBody = card.querySelector('.card-body');
    if (cardBody) {
      cardBody.addEventListener('click', () => {
        onCardBodyClick(safeName);
      });
    }
  });
}

// Pagination
function renderPagination(currentPage, totalPages) {
  const ui = getActiveUI();
  const container = document.querySelector(ui.paginationSel);
  if (!container) return;

  renderPaginationUniversal({
    container,
    currentPage,
    totalPages,
    mode: 'neighbors',

    showPrevNext: totalPages > 2,
    showArrows: totalPages >= 3,
    

    // ✅ беремо ті самі класи що в exercises
    classes: {
      page: 'exercises__page',
      active: 'active',
      prev: 'exercises__page-prev',
      next: 'exercises__page-next',
      first: 'exercises__page-first',
      last: 'exercises__page-last',
      arrow: 'exercises__page-arrow',
    },

    icons: {
      prev: '<',
      next: '>',
      first: '<<',
      last: '>>',
    },

    scrollToTop: true,
    scrollTarget: '.main-container',

    onPageChange(page) {
      activePage = page;
      return getCategories(activeFilter, page, PAGE_LIMIT);
    },
  });
}

// Clear Helpers
function clearCards() {
  const ui = getActiveUI();
  const container = document.getElementById(ui.cardsId);
  if (container) container.innerHTML = '';
}

function clearPagination() {
  const ui = getActiveUI();
  const container = document.querySelector(ui.paginationSel);
  if (container) container.innerHTML = '';
}

export function onCardBodyClick(nameValue) {
  const searchBox = document.querySelector('.filters__search');
  const categoriesBox = document.getElementById('cards-box');
  const exercisesBox = document.getElementById('exercises');
  const equipmentBox = document.getElementById('equipment-box');

  const tabsContainer = document.querySelector('[data-filters-tabs]');
  const activeTab = tabsContainer?.querySelector('.filters__tab--active');
  const activeFilterType = activeTab ? activeTab.dataset.filter : null;

  if (categoriesBox) categoriesBox.classList.add('hidden');
  if (exercisesBox) exercisesBox.classList.remove('hidden');
  if (equipmentBox) equipmentBox.classList.add('hidden');

  setOpenExercises(true);
  if (searchBox) searchBox.classList.add('filters__search--visible');

  const filtersSubtitle = document.querySelector('.filters__subtitle');
  if (filtersSubtitle) {
    filtersSubtitle.textContent =
      nameValue.charAt(0).toUpperCase() + nameValue.slice(1);
  }

  resetExercisesSearch();
  scrollToFilter();

  loadExercisesList({
    page: 1,
    filter: nameValue,
    type: activeFilterType,
    keyword: '',
  });
}

// Initial load
getCategories(activeFilter, activePage, PAGE_LIMIT);
